import React, {useEffect, useState} from 'react';

import './Patient.enroll.scss';

import Modal from 'react-modal';
import Select from "../forms/inputs/Select";
import {useLazyQuery, useMutation} from "@apollo/client";
import gqlSchemaLibrary from "../services/graphql.schemas";
import TextArea from "../forms/inputs/TextArea";
import {useTranslation} from "react-i18next";
import DropdownMultiSelectCliniciansTeams from "../forms/dropdown/dropdown.multiselectec.clinicians";
import {ModalLog} from "../services/interactions/elements/modal";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "none",
        padding: "0px",
        boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.38)",
    }
};
Modal.setAppElement('#root');

const _Modal = ModalLog(Modal);

function EnrollPatientDialog({ patient, isOpen, closeModal }) {
    const {t} = useTranslation(['common','participants']);
    const [programs, setPrograms] = useState([]);
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [note, setNote] = useState('');
    const [enrolling, setEnrolling] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        if (isOpen) {
            getPrograms({});
        }
    }, [isOpen]);

    const [getPrograms] = useLazyQuery(gqlSchemaLibrary.programs.query.getCurrentOrgPrograms, {
        onCompleted: (data) => {
            if (data.getCurrentOrgPrograms) {
                let ps = [];
                for (let i = 0; i < data.getCurrentOrgPrograms.length; i++) {
                    const p = data.getCurrentOrgPrograms[i];
                    if (patient.programId && patient.programId === p._id) {
                        continue;
                    }
                    ps.push({
                        label: p.name,
                        subLabel: (p.duration / 1000 / 60 / 60 / 24) + ' '+t('days'),
                        value: p._id
                    });
                }
                setPrograms(ps);
            }
        },
        fetchPolicy: 'cache-and-network'
    });

    const [enrollPatients] = useMutation(gqlSchemaLibrary.patients.mutations.enrollPatient, {
        onCompleted: ({enrollPatient}) => {
            console.log('[Patient Enroll] response: ', enrollPatient);
            setEnrolling(false);
            closeModalSuccess()
        }
    })

    const closeModalEmpty = () => {
        closeModal(null);
    }
    const closeModalSuccess = () => {
        closeModal(patient._id, selectedProgram);
    }
    const onChangeProgram = (p) => {
        setSelectedItems([]);
        setSelectedProgram(p);
    }
    const onChangeNote = (n) => {
        setNote(n);
    }
    const enrollPatient = () => {
        if (enrolling) {
            return;
        }
        if (patient) {
            setEnrolling(true);
            const patientIds = [patient._id];
            const users = selectedItems.filter((i) => i.type === 'User').map((u) => u.value);
            const teams = selectedItems.filter((i) => i.type === 'Team').map((u) => u.value);
            AuditTrail.sendLog(PAGES.PARTICIPANTS_LIST, {tab: 'button', event: 'onClick', action: 'button enrollment', patient_id: patient._id, program_id: selectedProgram, note: note});
            enrollPatients({
                variables:{
                    enrollments: {
                        patientIds: patientIds,
                        programId: selectedProgram,
                        note: note,
                        users: users,
                        teams: teams
                    }
                }
            });
        }
    }

    const onChange = (items) => {
        setSelectedItems(items);
    }

    const isDisabled = () => {
        return !selectedProgram;
    }

    return (
        <_Modal
            isOpen={!!isOpen}
            onRequestClose={closeModalEmpty}
            style={customStyles}
            contentLabel={t('participant-kit-assignment')}
            label="PatientEnroll"
            event={PAGES.PARTICIPANTS_LIST}
            eventParams={{patient_id: patient? patient._id : null}}>
            <div id="PatientDialog">
                <div className="__EnrollPatientTitle">
                    <h3>{t('participants:enroll-participant-program')}</h3>
                </div>
                <div className="row">
                    <span className="label">
                        {t('participants:program')}
                    </span>
                    <Select required={false} error={false} value={selectedProgram} onChange={onChangeProgram} label={''}
                            placeholder={'--'} options={programs} event={PAGES.PARTICIPANTS_LIST} eventParams={{_label: 'enroll selected program', patient_id: patient? patient._id : null}} />
                </div>
                <div className="row">
                    <span className="label">
                        {t('participants:assign-clinician')}
                    </span>
                    <DropdownMultiSelectCliniciansTeams program={selectedProgram} displayLabel={t('participants:choose-the-options')} items={selectedItems} onChange={onChange} />
                </div>
                <div className="row">
                    <span className="label">
                        {t('participants:enrollment-note')}
                    </span>
                    <TextArea value={note} onChange={onChangeNote} />
                </div>
                <div className="modalFooter">
                    <button className="button link" onClick={closeModalEmpty}>{t('common:cancel')}</button>
                    <button className="button primary" onClick={enrollPatient} disabled={isDisabled()}>{t('participants:enroll')}</button>
                </div>
            </div>
        </_Modal>
    )
}

export default EnrollPatientDialog;
